<script setup lang="ts">
const { country, language } = useRouteHelper()
const { customer, userData } = await useCustomer()
const { ts } = useI18n()

const contactFrame = ref<HTMLIFrameElement>()

const height = ref<string>('0px')
const getHeight = (e: any) => {
  height.value = e.height
}

watch(height, newVal => handleScrollToTopOnSubmit(newVal))

/** The iframe's height reduces greatly on form submit.
 * Watching this value, I can scroll to top if the iframe is too small to be seen */
const handleScrollToTopOnSubmit = (iFrameHeightMessage: string) => {
  // This const has been measured inside webtools for the smallest viewport
  const MAX_HEIGHT_FOR_SUBMITTED_FORM = 303
  const newHeight = Number.parseInt(iFrameHeightMessage.replaceAll('px', ''))
  if (isNaN(newHeight)) return
  if (newHeight < MAX_HEIGHT_FOR_SUBMITTED_FORM) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
const gender = computed(() => {
  if (customer?.value?.gender === 'male') {
    return ts('pdp.reserveInStore.personalInfo.gender.mr')
  } else if (customer?.value?.gender === 'female') {
    return ts('pdp.reserveInStore.personalInfo.gender.ms')
  } else {
    return ''
  }
})

const data = computed(() => ({
  isoCode: country,
  language: language,
  action: '',
  userDetails: {
    data: [
      {
        Key: 'nickname',
        Label: 389,
        IsVisible: true,
        Info: userData?.value?.nickname ?? null,
      },
      {
        Key: 'title',
        Label: 329,
        IsVisible: true,
        Info: gender.value,
      },
      {
        Key: 'name',
        Label: 156,
        IsVisible: true,
        Info: customer?.value.firstName ?? '',
      },
      {
        Key: 'furiganaName',
        Label: 157,
        IsVisible: false,
        Info: null,
      },
      {
        Key: 'surname',
        Label: 266,
        IsVisible: true,
        Info: customer?.value.lastName ?? null,
      },
      {
        Key: 'furiganaSurname',
        Label: 267,
        IsVisible: false,
        Info: null,
      },
      {
        Key: 'email',
        Label: 96,
        IsVisible: true,
        Info: customer?.value.email ?? null,
      },
      {
        Key: 'gender',
        Label: 114,
        IsVisible: true,
        Info: customer?.value.gender,
      },
      {
        Key: 'birthday',
        Label: 27,
        IsVisible: true,
        Info: customer?.value.dateOfBirth ?? '',
      },
      {
        Key: 'country',
        Label: 55,
        IsVisible: true,
        Info: country,
      },
    ],
    statusCode: 200,
  },
}))
const loaded = ref(false)

const sendMessageToIframe = () => {
  if (!contactFrame.value?.contentWindow) {
    return
  }
  const message = JSON.parse(JSON.stringify(data.value))
  contactFrame.value.contentWindow.postMessage(
    message,
    'https://contactuspageembedded.armani.com'
  )
}

onMounted(() => {
  useEventListener(window, 'message', event => {
    if (event.origin !== 'https://contactuspageembedded.armani.com') return
    loaded.value = true
    if (event.data.action === 'resize') getHeight(event.data)
  })
})
</script>

<template>
  <div class="flex h-max w-full items-center justify-center p-2">
    <DefaultIconsLoader v-if="!loaded" />
    <iframe
      id="contactFrame"
      ref="contactFrame"
      :title="$ts('customerService.contactUs')"
      src="https://contactuspageembedded.armani.com/Armani/ContactForm.html"
      frameborder="0"
      class="w-full md:mt-12"
      :class="[{ hidden: !loaded }]"
      :height="height"
      :onload="sendMessageToIframe()"
    />
  </div>
</template>
